import { render, staticRenderFns } from "./AS_DocumentCardComponents.vue?vue&type=template&id=3100781e&scoped=true&"
import script from "./AS_DocumentCardComponents.vue?vue&type=script&lang=js&"
export * from "./AS_DocumentCardComponents.vue?vue&type=script&lang=js&"
import style0 from "./AS_DocumentCardComponents.vue?vue&type=style&index=0&id=3100781e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3100781e",
  null
  
)

export default component.exports